import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=a1a104be&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"
import style0 from "./clients.vue?vue&type=style&index=0&id=a1a104be&prod&scoped=true&lang=css"
import style1 from "./clients.vue?vue&type=style&index=1&id=a1a104be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a104be",
  null
  
)

export default component.exports